import React from 'react';
import {
  Box,
  Grid,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
} from 'components/mui';
import { AddIcon, RemoveIcon } from 'components/icons';
import useKeywordManagement from './useKeywordManagement';
import LoadingBackdrop from 'components/LoadingBackdrop';
import {
  KeywordList,
  KeywordForm,
  KeywordSearch,
} from 'containers/pages/keywordManagement/components';

function KeywordManagement() {
  const { state, handler } = useKeywordManagement();

  return (
    <Box
      component="main"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        p: { xs: 2, sm: 3 },
      }}
    >
      {/* Header row */}
      <Grid
        container
        alignItems="stretch"
        spacing={2}
        wrap="nowrap"
      >
        <Grid item>
          <Button
            variant="contained"
            startIcon={state.isOpenForm ? <RemoveIcon /> : <AddIcon />}
            onClick={handler.onToggleForm}
            sx={{
              display: 'flex',
              alignItems: 'center',
              px: 2,
              height: '100%',
              whiteSpace: 'nowrap',
            }}
          >
            <Box sx={{ display: { xs: 'none', sm: 'inline' } }}>NEW KEYWORD</Box>
            <Box sx={{ display: { xs: 'inline', sm: 'none' } }}>NEW</Box>
          </Button>
        </Grid>

        <Grid item xs>
          <Box sx={{ display: 'flex', alignItems: 'center', height: '100%' }}>
            <KeywordSearch
              searchInput={state.searchInput}
              onSearchInput={handler.onSearchInput}
              onReset={handler.onResetSearch}
            />
          </Box>
        </Grid>
      </Grid>

      {/* New Keyword Dialog */}
      <Dialog open={state.isOpenForm} onClose={handler.onToggleForm} maxWidth="sm" fullWidth>
        <DialogTitle>New Keyword</DialogTitle>
        <DialogContent>
          <Box sx={{ pt: 1 }}>
            <KeywordForm mode="add" onSave={handler.onSaveKeyword} />
          </Box>
        </DialogContent>
      </Dialog>

      {/* Main keyword list */}
      <KeywordList
        keywords={state.searchedKeywords}
        onSave={handler.onSaveKeyword}
        onDelete={handler.onDeleteKeyword}
      />

      <LoadingBackdrop open={state.isLoading} />
    </Box>
  );
}

export default KeywordManagement;
